<script lang="ts">
  import Message from "./Message.svelte"
  import { onMount } from 'svelte'
  import axios from 'axios'

  let loading = $state(false)
  let page = $state(0)
  let messages = $state([])

  onMount(() => {
    window.App.subscribe("superadmin.messages.updated", prepend_message)
    loadMore()
  })

  /*
  * Fetch the next page of older messages
  */
  function loadMore() {
    if (!loading) {
      loading = true

      axios.get("/superadmin/messages/live_stream.json", { params: { page: page + 1 } })
        .then(append_messages)
        .catch((a, b, c) => {
          console.log("fail a: ", a)
          console.log("fail b: ", b)
          console.log("fail c: ", c)
        })
    }
  }

  /*
  * Add the next page of messages to the end of the list
  */
  function append_messages(response) {
    messages = messages.concat(response.data)
    page += 1
    loading = false
  }

  /*
  * Adds a new message to the top of the list, when one is
  * received by MessageBus
  *
  * evt.detail: { message: Object }
  */
  function prepend_message(evt) {
    let msg = evt.detail.message

    if (!messages.some(item => item.id === msg.id)) {
      messages = [msg, ...messages]
    }
  }
</script>

<div>
  <ul class="live-stream">
    {#each messages as message (message.id)}
      <li>
        <Message {message} />
      </li>
    {/each}
  </ul>
  <hr />
  <p>
    <button onclick={loadMore} class="btn btn-primary stretch js-load-more">Load more</button>
  </p>
</div>
